module.exports = __webpack_public_path__ + "static/media/sky-terrace-1.20023026.jpg";